import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function ThankYou() {
  const location = useLocation();
  const name = location.state?.name;

  useEffect(() => {
    document.title = "Gracias — Monderavello";
    document.documentElement.setAttribute("lang", "es-MX");
  }, []);

  return (
    <main
      data-testid="thank-you-page"
      className="min-h-[70vh] bg-[#F8F9FA] flex items-center"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#1B4D3E] text-white mx-auto">
          <CheckCircle2 size={32} />
        </div>
        <h1 className="mt-6 text-4xl sm:text-5xl font-bold tracking-tight text-[#0F2942]">
          ¡Gracias por confiar en Monderavello!
        </h1>
        <p className="mt-4 text-base sm:text-lg text-[#475569] leading-relaxed">
          {name ? `Hola ${name}, ` : ""}
          hemos recibido correctamente tu solicitud. Un asesor ciudadano de Monderavello se pondrá en contacto contigo en un plazo máximo de 48 horas hábiles para revisar tu situación y explicarte los programas de apoyo financiero vigentes en 2026 a los que puedes acceder.
        </p>
        <p className="mt-4 text-sm text-[#475569] leading-relaxed">
          Mientras tanto, revisa tu bandeja de entrada: recibirás una copia de confirmación con información básica sobre nuestros servicios y tus derechos como titular de datos personales conforme a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (México).
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            data-testid="thank-you-back-home"
            className="inline-flex items-center rounded-md bg-[#0F2942] hover:bg-[#173A5E] text-white px-6 py-3 text-sm font-semibold"
          >
            Volver al inicio
          </Link>
          <a
            href="mailto:contacto@monderavello.com"
            data-testid="thank-you-contact"
            className="inline-flex items-center rounded-md border border-[#0F2942] text-[#0F2942] px-6 py-3 text-sm font-semibold hover:bg-white"
          >
            Escribir a contacto@monderavello.com
          </a>
        </div>
        <p className="mt-10 text-xs text-[#64748B]">
          © 2026 Monderavello Consultores Financieros, S.A. de C.V.
        </p>
      </div>
    </main>
  );
}
